// ReportsPage.js
import React, { useState, useEffect } from "react";
import { Table, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ReportsPage = () => {
  const [folders, setFolders] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchResultsFolders = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/list-results-folders`
        );
        if (!response.ok) {
          throw new Error("Failed to load results folders");
        }
        const data = await response.json();
        // Extract name and created_at
        const foldersWithTime = data.map((folder) => ({
          name: folder.name,
          created_at: new Date(folder.created_at).toLocaleString(), // Format the date
        }));
        setFolders(foldersWithTime);
      } catch (error) {
        setErrorMessage(error.message);
      }
    };
    fetchResultsFolders();
  }, []);

  const handleViewReport = async (folder) => {
    try {
      const response = await fetch(
        `https://reactserver-757095405629.us-central1.run.app/api/load-results-json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ folder_name: folder }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to load report data");
      }
      const jsonData = await response.json();
      navigate("/report", { state: { jsonData } });
    } catch (error) {
      setErrorMessage("Failed to load report");
    }
  };

  return (
    <div className="reports-page">
      <h1>Reports</h1>
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>File Name</th>
            <th>Created At</th> {/* Add a new column for Created At */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {folders.map((folder, index) => (
            <tr key={index}>
              <td>{folder.name !== "None" ? folder.name : "Unnamed File"}</td>{" "}
              {/* Handle None case */}
              <td>{folder.created_at}</td>{" "}
              {/* Display formatted creation time */}
              <td>
                <Button
                  variant="primary"
                  onClick={() => handleViewReport(folder.name)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ReportsPage;
